






import { defineComponent } from '@nuxtjs/composition-api';

import AfterpayLogo from './logos/AfterpayLogo.vue';
import ZipLogo from './logos/ZipLogo.vue';

export default defineComponent({
  name: 'ThirdPartyLogo',
  components: {
    AfterpayLogo,
    ZipPayLogo: ZipLogo,
  },
  props: {
    logo: {
      type: String,
      required: true,
    },
  },
  computed: {
    svgLogo() {
      switch (this.logo) {
        case 'afterpay-logo':
          return AfterpayLogo;
        case 'zip-logo':
          return ZipLogo;
        default:
          return null;
      }
    },
  },
});
